<template>
  <div v-cloak>
    <div class="vx-card mb-6">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <table class="basic-tbl" id="colored-table">
              <thead>
                <tr>
                  <th style="width: 10%">{{ $t("OriginWarehouse") }}</th>
                  <th style="width: 10%">{{ $t("DestinationWarehouse") }}</th>
                  <th style="width: 15%">{{ $t("Description") }}</th>
                  <th style="width: 12.5%">{{ $t("OperatorName") }}</th>
                  <th style="width: 12.5%">{{ $t("Applicant") }}</th>
                  <th style="width: 10%">{{ $t("AutomationCode") }}</th>
                  <th style="width: 15%">{{ $t("CreateOn") }}</th>
                  <th style="width: 12.5%">
                    {{ $t("DocumentRegistrationDate") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width: 10%">
                    {{ headerInfo.storeName }}
                  </td>
                  <td style="width: 10%">
                    {{ headerInfo.destinationStoreName }}
                  </td>
                  <td style="width: 15%">{{ headerInfo.description }}</td>
                  <td style="width: 12.5%">
                    {{ headerInfo.inventoryOperatorName }}
                  </td>
                  <td style="width: 12.5%">
                    {{ headerInfo.inventoryRequesterName }}
                  </td>
                  <td style="width: 10%">
                    {{ headerInfo.automationCode }}
                  </td>
                  <td style="width: 15%; direction: ltr">
                    {{ headerInfo.persianDateTime }}
                  </td>
                  <td style="width: 12.5%; direction: ltr">
                    {{ headerInfo.persianRegisterClock }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('OriginInventory'), sort: 'OriginInventory' },
                {
                  title: $t('DestinationInventory'),
                  sort: 'DestinationInventory',
                },
                { title: $t('ProductName'), sort: 'ProductName' },
                { title: $t('ItemCode'), sort: 'ProductName' },
                { title: $t('Count'), sort: 'Count' },
                { title: $t('Serial'), sort: 'Serial' },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 20%">
                  {{ row.shelveName }}
                </td>
                <td style="width: 20%">
                  {{ row.destinationShelveName }}
                </td>
                <td style="width: 27%">
                  {{ row.stockName }}
                </td>
                <td style="width: 15%">
                  {{ row.itemCode }}
                </td>
                <td style="width: 10%">
                  {{ row.countOfCheckIn }}
                </td>
                <td style="width: 15%">
                  <span v-if="row.stockType == 1">
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="custom-border-btn"
                      @click="
                        viewSerials(
                          row.inventoryTransactionId,
                          row.shelveId,
                          row.stockId
                        )
                      "
                      >{{ $t("ViewSerials") }}</vs-button
                    >
                  </span>
                  <span v-else>-</span>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
    <serials-list
      :show="SerialsListPopup"
      @finish="onfinish"
      @close="closeSerialsListPopup"
      :popupService="popupService"
    ></serials-list>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import SerialsList from "./SerialsList.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "warehouseManagement_TransferTransactions_Details",

  components: {
    DataGrid,
    SerialsList,
  },
  data() {
    var id = this.$route.params.id;
    return {
      gridDataSource: {
        type: "app",
        service: "Inventory/api/TransferTransactionsQuery/" + id + "/0",
      },
      gridSearchData: {},
      SerialsListPopup: false,
      popupService: "",
    };
  },
  computed: {
    ...mapGetters({
      headerInfo: "transferTransactions/details",
    }),
  },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      fetchSingle: "transferTransactions/fetchSingle",
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchSingle(id);
    },
    viewSerials(inventoryTransactionId, shelveId, stockId) {
      this.popupService =
        "/Inventory/api/InventoryTransactionsQuery/serials/" +
        inventoryTransactionId +
        "/" +
        shelveId +
        "/" +
        stockId;
      this.SerialsListPopup = true;
    },
    closeSerialsListPopup() {
      this.SerialsListPopup = false;
    },
    onfinish() {
      this.closeSerialsListPopup();
      this.$refs.grid.renderGrid(1, true);
    },
  },
};
</script>
